'use client';

import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { motion, AnimatePresence } from 'framer-motion';

export default function CookieConsent() {
    const [showBanner, setShowBanner] = useState(false);

    const cookieOptions = {
        expires: 365,
        sameSite: 'lax' as const,
        secure: typeof window !== 'undefined' ? window.location.protocol === 'https:' : true,
    };

    useEffect(() => {
        // Vérifier si l'utilisateur a déjà donné son consentement
        const consent = Cookies.get('cookieConsent');
        if (!consent) {
            // Afficher le banner après un court délai
            setTimeout(() => setShowBanner(true), 1000);
        }
    }, []);

    const acceptCookies = () => {
        Cookies.set('cookieConsent', 'accepted', cookieOptions);
        window.dispatchEvent(new Event('cookie-consent-updated'));
        
        // Mettre à jour le consentement Google Analytics
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                analytics_storage: 'granted'
            });
        }
        
        setShowBanner(false);
    };

    const declineCookies = () => {
        Cookies.set('cookieConsent', 'declined', cookieOptions);
        window.dispatchEvent(new Event('cookie-consent-updated'));

        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                analytics_storage: 'denied'
            });
        }

        setShowBanner(false);
    };

    return (
        <AnimatePresence>
            {showBanner && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.25, ease: 'easeOut' }}
                    className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-50"
                >
                    {/* Couleurs neutres : le bandeau s'affiche sur le site et sur /portfolio. Refuser est aussi visible qu'accepter (recommandation CNIL). */}
                    <div role="dialog" aria-labelledby="cookie-title" className="rounded-md border border-[#e3e1da] bg-[#fbfaf7] p-6 text-[#111111] shadow-[0_12px_40px_rgba(17,17,17,0.12)]">
                        <h3 id="cookie-title" className="mb-2 text-base font-semibold">
                            Mesure d’audience
                        </h3>
                        <p className="mb-5 text-sm leading-6 text-[#63635e]">
                            Avec votre accord, j’utilise Google Analytics pour savoir quelles pages sont lues. Rien n’est utilisé à des fins publicitaires.
                        </p>
                        <div className="flex gap-3">
                            <button onClick={acceptCookies} className="flex-1 rounded-md bg-[#111111] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#333333]">
                                Accepter
                            </button>
                            <button onClick={declineCookies} className="flex-1 rounded-md border border-[#111111] px-5 py-2.5 text-sm font-medium text-[#111111] transition-colors hover:bg-[#eceae4]">
                                Refuser
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
